import { render, staticRenderFns } from "./Pradosur.vue?vue&type=template&id=57521b3e"
import script from "./Pradosur.vue?vue&type=script&lang=js"
export * from "./Pradosur.vue?vue&type=script&lang=js"
import style0 from "./Pradosur.vue?vue&type=style&index=0&id=57521b3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports